import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { HttpClient } from '@angular/common/http';
import { JobCategorySerializer } from '../model/serializer/jobCategory-serialize';
import { JobCategory } from '../model/jobCategory';

import { environment } from '@environments/environment';

@Injectable({ providedIn: 'root' })
export class JobCategoryService extends ApiService<JobCategory> {

  constructor(httpClient: HttpClient) {
    super(httpClient,
      environment.apiUrl,
      'job/category',
      new JobCategorySerializer());
  }
}
